import request, { withRetry as retry } from '@flowio/request';
import config from './config';

function createShopifySession(shop, callback) {
  retry(request.anonymous)({
    url: "".concat(config.API_BASE_URI, "/shopify/shops/").concat(encodeURIComponent(shop), "/sessions"),
    data: {},
    method: 'POST',
    envelope: true
  }, callback);
}

export default createShopifySession;
//# sourceMappingURL=create-shopify-session.js.map